/* ============================================================
   OLIVE TREE MARKETPLACE — homepage behavior
   Small, dependency-free, progressive enhancement only.
   Everything works (navigation, forms, cart) with JS disabled.
   ============================================================ */
(function () {
  'use strict';

  document.documentElement.classList.remove('no-js');

  /* ---------- Header: solid-after-scroll + mobile menu ---------- */
  var header = document.querySelector('.otm-header');
  if (header) {
    if (header.classList.contains('otm-header--transparent')) {
      var setScrolled = function () {
        header.classList.toggle('is-scrolled', window.scrollY > 24);
      };
      var ticking = false;
      window.addEventListener(
        'scroll',
        function () {
          if (!ticking) {
            window.requestAnimationFrame(function () {
              setScrolled();
              ticking = false;
            });
            ticking = true;
          }
        },
        { passive: true }
      );
      setScrolled();
    }

    var burger = header.querySelector('[data-otm-menu-toggle]');
    if (burger) {
      burger.addEventListener('click', function () {
        var open = header.classList.toggle('is-open');
        burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }
  }

  /* ---------- Reveal on scroll (fade / lift; reduced-motion safe) ---------- */
  var reveals = document.querySelectorAll('.otm-reveal');
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reveals.length) {
    if (reducedMotion || !('IntersectionObserver' in window)) {
      reveals.forEach(function (el) { el.classList.add('is-visible'); });
    } else {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        },
        { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
      );
      reveals.forEach(function (el) { observer.observe(el); });
    }
  }

  /* ---------- Quick Add (fetch enhancement over a real cart form) ---------- */
  document.querySelectorAll('form[data-otm-quick-add]').forEach(function (form) {
    form.addEventListener('submit', function (event) {
      if (!window.fetch) return; // fall through to normal form POST → /cart
      event.preventDefault();
      var button = form.querySelector('button[type="submit"]');
      if (button && button.getAttribute('aria-disabled') === 'true') return;
      var original = button ? button.textContent : '';
      if (button) {
        button.setAttribute('aria-disabled', 'true');
        button.textContent = button.getAttribute('data-adding-text') || original;
      }

      fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: parseInt(form.querySelector('[name="id"]').value, 10), quantity: 1 }]
        })
      })
        .then(function (response) {
          if (!response.ok) throw new Error('cart-add-failed');
          return fetch(
            (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart.js',
            { headers: { Accept: 'application/json' } }
          );
        })
        .then(function (response) { return response.json(); })
        .then(function (cart) {
          document.querySelectorAll('[data-otm-cart-count]').forEach(function (el) {
            el.textContent = cart.item_count;
            el.setAttribute('data-count', cart.item_count);
          });
          if (button) {
            button.classList.add('is-added');
            button.textContent = button.getAttribute('data-added-text') || original;
            window.setTimeout(function () {
              button.classList.remove('is-added');
              button.textContent = original;
              button.removeAttribute('aria-disabled');
            }, 2000);
          }
        })
        .catch(function () {
          // Recover honestly: fall back to the standard form flow
          // (form.submit() does not re-trigger this listener).
          if (button) {
            button.textContent = original;
            button.removeAttribute('aria-disabled');
          }
          form.submit();
        });
    });
  });
})();
